import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getCarousel } from '../../services'
import { CarouselQueryKeys } from '@/modules/client-setting/keys'
import { GetCarouselResponse } from '@/modules/client-setting/type'

export default function useQueryGetCarousel(
	props?: UseBaseQueryOptions<GetCarouselResponse>,
) {
	return useQuery({
		queryKey: [CarouselQueryKeys.GetCarousel],
		queryFn: () => getCarousel(),
		...props,
	})
}
